import React from "react";

const VegNonVegToggle = ({ value = [], onChange }) => {
  const toggle = (type) => {
    if (value.includes(type)) {
      onChange(value.filter((v) => v !== type));
    } else {
      onChange([...value, type]);
    }
  };

  return (
    <div>
  

      <div className="flex gap-3">
        <button
          type="button"
          onClick={() => toggle("VEG")}
          className={`flex items-center gap-2 px-4 py-2 rounded-full border text-sm font-medium transition
            ${
              value.includes("VEG")
                ? "bg-green-200  border-green-300"
                : "bg-white text-gray-700 border-gray-300 hover:bg-green-50"
            }`}
        >
          <span className="w-3 h-3 rounded-full bg-green-600"></span>
          Veg
        </button>

        <button
          type="button"
          onClick={() => toggle("NONVEG")}
          className={`flex items-center gap-2 px-4 py-2 rounded-full border text-sm font-medium transition
            ${
              value.includes("NONVEG")
                ? "bg-red-300  border-red-300"
                : "bg-white text-gray-700 border-gray-300 hover:bg-red-50"
            }`}
        >
          <span className="w-3 h-3 rounded-full bg-red-600"></span>
          Non-Veg
        </button>
      </div>
    </div>
  );
};

export default VegNonVegToggle;
